import ScAccordion from '@garmin/support-components/src/components/ScAccordion/index.vue';
import { mapActions, mapGetters } from 'vuex';
import { fireUtagEvent } from '@garmin/support-analytics';
import TranslationsMixin from '../../mixins/translations';
import LandingAnalytics from './LandingAnalytics';
import exchangeTypes from '../../config/exchangeTypes';

export default {
  name: 'LandingView',
  components: {
    ScAccordion,
  },
  mixins: [TranslationsMixin],
  beforeRouteEnter(to, from, next) {
    next(async (ctx) => {
      await ctx.hydrateViewState(to);
    });
  },
  data() {
    return {
      analyticsInstance: new LandingAnalytics(),
      submitDisabled: false,
      internalFormValues: {},
      verificationFailureErrors: [],
    };
  },
  computed: {
    ...mapGetters('customer/', [
      'getCountriesTransformed',
      'findSelectedCountry',
      'exchangeIdentifier',
      'deviceVerificationResponse',
      'isDeviceInOrUnknownWarranty',
      'suppliedFormData',
      'getDeviceProductPageUrl',
      'provideErrorToProductPage',
      'getSelectedCountryCode',
    ]),
    ...mapGetters('order', ['isSerialRmaAssociated']),
    getProductNotIdentifiedLink() {
      return this.translations.exceptionProductNotIdentifiedLinkText;
    },
    isValidSerialNumber() {
      return this.deviceVerificationResponse?.serialNumberInDb;
    },
  },
  methods: {
    ...mapActions(['reset']),
    ...mapActions('customer/', [
      'fetchCountries',
      'updateSuppliedValidationData',
      'updateExchangeIdentifer',
      'deviceVerification',
    ]),
    ...mapActions('order', ['checkSerialRmaAssociation']),
    deviceVerificationSuccessful() {
      return (
        this.deviceVerificationResponse
        && (!this.isDeviceInOrUnknownWarranty || this.deviceVerificationResponse?.autoRMAScenario)
        && this.deviceVerificationResponse?.paidRMADetails?.currency
        && this.deviceVerificationResponse.serialNumberInDb
        && this.deviceVerificationResponse.rmaOutboundProductDetail
      );
    },
    async hydrateViewState(to) {
      this.reset();
      this.updateExchangeIdentifer({
        exchangeType: exchangeTypes[to.query.exchangeType],
        exchangeId: to.query.exchangeId,
      });

      await this.fetchCountries();
      this.analyticsInstance.triggerPSCCaseIdAnalytics(this.exchangeIdentifier || '');
    },
    async onDeviceVerificationSubmitted(formData, node) {
      const { serialNumber, emailAddress, selectedCountryRegion } = formData;
      this.updateSuppliedValidationData(formData);
      this.submitDisabled = true;
      this.verificationFailureErrors = [];

      await this.deviceVerification({
        serialNumber,
        emailAddress,
        country: this.getSelectedCountryCode,
        locale: selectedCountryRegion,
        caseId: this.exchangeIdentifier,
      });

      await this.checkSerialRmaAssociation({
        serialNumber,
      });

      if (this.deviceVerificationSuccessful() && !this.isSerialRmaAssociated) {
        this.analyticsInstance.triggerVerificationSubmissionAnalytics(this.isValidSerialNumber, this.deviceVerificationResponse);
        this.$router.push({ name: 'exchangeDetailsView', query: this.$route.query });
      } else {
        this.analyticsInstance.triggerVerificationSubmissionAnalytics(this.isValidSerialNumber, this.deviceVerificationResponse, serialNumber);
        this.verificationFailureErrors = [this.translations.exceptionMessageProductIdentified];

        // eslint-disable-next-line max-len
        if (this.isSerialRmaAssociated) node.setErrors({ serialNumber: this.translations.orderInformationForm.errors.invalidSerialNumberAlreadyAssociated });
      }

      this.submitDisabled = false;
    },
    onVerificationFailureLinkClicked(payload) {
      const {
        // eslint-disable-next-line camelcase
        event_category, event_action, event_label, link,
      } = payload;
      // eslint-disable-next-line camelcase
      fireUtagEvent({
        event_category, event_action, event_label,
      });
      if (link) window.open(link, '_self');
    },
  },
};
